import React, { Component } from "react";

class ExtensionVersions extends Component {
  render() {
    return (
      <div>
        <p>SmartConsole extensions platform versions</p>

        <table cellSpacing="0" cellPadding="0" className="tablesorter">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Version</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>SmartConsole Release</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>1.0</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>R80.20 GA</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>1.1</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>R80.20.M2</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>1.2</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>R80.30, R80.40, R81, R81.10</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>1.3</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>R81.20, R82, R82.10, R82.20</span>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ExtensionVersions;
